export const ARTICLE_BODY_COMPOSITION = Object.freeze({
  kind: 'article',
  mediaPlacement: 'inline',
  insertMediaAtStart: false,
  maxMediaGroups: Infinity,
  maxInteractiveBlocks: Infinity,
  maxArtworksPerGroup: 5,
  supportsTextFormatting: true,
});

export const POST_BODY_COMPOSITION = Object.freeze({
  kind: 'post',
  mediaPlacement: 'lead',
  insertMediaAtStart: true,
  maxMediaGroups: 1,
  maxInteractiveBlocks: 1,
  maxArtworksPerGroup: 1,
  supportsTextFormatting: false,
});

export function usesLeadMedia(composition) {
  return composition.mediaPlacement === 'lead';
}

export function canAddMedia(composition, mediaGroupCount) {
  return mediaGroupCount < composition.maxMediaGroups;
}

export function canAddInteractiveBlock(composition, interactiveBlockCount) {
  return interactiveBlockCount < composition.maxInteractiveBlocks;
}
